import { render, staticRenderFns } from "./stockor.vue?vue&type=template&id=82c0b9e0&"
import script from "./stockor.vue?vue&type=script&lang=js&"
export * from "./stockor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports